'use client';

/**
 * Light / dark switch for pages built with the v2 (game) design. Dark is the default. The choice is saved in
 * localStorage ('lp-theme') and applied before first paint by the script in the root layout. The button only shows on
 * pages that use the design (the CSS hides it elsewhere: see buildSkinCss in components/dev/skin-game-css.ts).
 */
export function LPThemeToggle({ className = '' }: { className?: string }) {
  const toggle = () => {
    const html = document.documentElement;
    const next = html.getAttribute('data-skin-mode') === 'light' ? 'dark' : 'light';
    html.setAttribute('data-skin-mode', next);
    try { localStorage.setItem('lp-theme', next); } catch { /* storage blocked: the switch still works for this page */ }
  };
  return (
    <button type="button" onClick={toggle} className={`lp-theme-toggle ${className}`} aria-label="Switch between light and dark mode" title="Light or dark mode">
      {/* sun (shown in dark mode: switch to light) */}
      <svg className="lp-tt-sun" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
        <circle cx="12" cy="12" r="4.2" /><path d="M12 2.5v2.2M12 19.3v2.2M2.5 12h2.2M19.3 12h2.2M5.3 5.3l1.6 1.6M17.1 17.1l1.6 1.6M18.7 5.3l-1.6 1.6M6.9 17.1l-1.6 1.6" />
      </svg>
      {/* moon (shown in light mode: switch to dark) */}
      <svg className="lp-tt-moon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M20.5 14.2A8.5 8.5 0 0 1 9.8 3.5a8.5 8.5 0 1 0 10.7 10.7Z" />
      </svg>
    </button>
  );
}
